import storeApis from "./storeApi";

const authHeaders = (token) => ({
  Accept: "application/json",
  Authorization: `Bearer ${token}`,
});

/** GET — logo URL, colors, disclaimer */
export function getCustomerBranding(authToken) {
  return storeApis.get("customer/branding", { headers: authHeaders(authToken) });
}

/** GET — tenant branding for unauthenticated routes (e.g. login page). No auth header. */
export function getPublicTenantBranding() {
  return storeApis.get("public/tenant-branding", {
    headers: { Accept: "application/json" },
  });
}

/** POST — multipart when logo included; partial updates supported */
export function updateCustomerBranding(authToken, fields) {
  const fd = new FormData();
  if (fields.primary_color !== undefined) {
    fd.append("primary_color", fields.primary_color ?? "");
  }
  if (fields.secondary_color !== undefined) {
    fd.append("secondary_color", fields.secondary_color ?? "");
  }
  if (fields.disclaimer !== undefined) {
    fd.append("disclaimer", fields.disclaimer ?? "");
  }
  if (fields.logoFile) {
    fd.append("logo", fields.logoFile);
  }
  return storeApis.post("customer/branding", fd, {
    headers: authHeaders(authToken),
  });
}

export function getRecommendedQuestions(authToken) {
  return storeApis.get("customer/recommended-questions", {
    headers: authHeaders(authToken),
  });
}

export function createRecommendedQuestion(authToken, body) {
  return storeApis.post("customer/recommended-questions", body, {
    headers: authHeaders(authToken),
  });
}

export function updateRecommendedQuestion(authToken, body) {
  return storeApis.put("customer/recommended-questions", body, {
    headers: authHeaders(authToken),
  });
}

export function deleteRecommendedQuestion(authToken, id) {
  return storeApis.delete("customer/recommended-questions", {
    headers: authHeaders(authToken),
    data: { id },
  });
}

export function getRecommendedQuestionSections(authToken) {
  return storeApis.get("customer/recommended-question-sections", {
    headers: authHeaders(authToken),
  });
}

export function createRecommendedQuestionSection(authToken, body) {
  return storeApis.post("customer/recommended-question-sections", body, {
    headers: authHeaders(authToken),
  });
}

export function updateRecommendedQuestionSection(authToken, body) {
  return storeApis.put("customer/recommended-question-sections", body, {
    headers: authHeaders(authToken),
  });
}

export function deleteRecommendedQuestionSection(authToken, id) {
  return storeApis.delete("customer/recommended-question-sections", {
    headers: authHeaders(authToken),
    data: { id },
  });
}
